export const SUCCESSFUL_LOGIN = "SUCCESSFUL_LOGIN";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_IMPERSONATED_CLIENT = "SET_IMPERSONATED_CLIENT";
export const SET_REGISTRATION_USER = "SET_REGISTRATION_USER";
export const SET_RESET_PASSWORD = "SET_RESET_PASSWORD";
export const SET_USER_PASSWORD_RESET = "SET_USER_PASSWORD_RESET";
export const SET_TERMS_ACCEPTED = "SET_TERMS_ACCEPTED";
export const STOP_IMPERSONATING_CLIENT = "STOP_IMPERSONATING_CLIENT";

export const SET_USER_PREFERENCES = "SET_USER_PREFERENCES";
export const SET_AD_HOC_FEE_AUTH = "SET_AD_HOC_FEE_AUTH";
export const SET_DOCUMENT_PREFERENCES = "SET_DOCUMENT_PREFERENCES";
export const SET_DOCUMENT_DELIVERY_OPTIONS = "SET_DOCUMENT_DELIVERY_OPTIONS";
export const SET_USER_LOCATION_ID = "SET_USER_LOCATION_ID";

export function successfulLogin(response, username) {
    return {
        type: SUCCESSFUL_LOGIN,
        response,
        username
    };
}

export function setCurrentUser(client) {
    return {
        type: SET_CURRENT_USER,
        client
    };
}

export function setImpersonatedClient(client) {
    return { type: SET_IMPERSONATED_CLIENT, client };
}

export function stopImpersonating() {
    return { type: STOP_IMPERSONATING_CLIENT };
}

export function setRegistrationUser(username) {
    return {
        type: SET_REGISTRATION_USER,
        username
    };
}

export function setResetPassword(resetPassword) {
    return {
        type: SET_RESET_PASSWORD,
        resetPassword
    };
}

export function setTermsAccepted() {
    return {
        type: SET_TERMS_ACCEPTED
    };
}

export function setUserPreferences(preferences) {
    return {
        type: SET_USER_PREFERENCES,
        preferences
    };
}

export function setAdHocFeeAuth(newStatus) {
    return {
        type: SET_AD_HOC_FEE_AUTH,
        newStatus
    };
}

export function setDocumentDeliveryPreferences(documentPreferences) {
    return {
        type: SET_DOCUMENT_PREFERENCES,
        documentPreferences
    };
}

export function setDocumentDeliveryOptions(options) {
    return {
        type: SET_DOCUMENT_DELIVERY_OPTIONS,
        options
    };
}

export function setUserLocationId(locationId) {
    return {
        type: SET_USER_LOCATION_ID,
        locationId
    };
}
